import { groq } from 'next-sanity';

const contactInformationQuery = groq`
  *[_id == "contactInformation"][0] {
  ...,
}
`;

export default contactInformationQuery;
